export enum EnumAtlasAccessSearchType {
  Email = 'email',
  Client = 'client'
}

export enum EnumAtlasEntityType {
  Client = 'client',
  Commercial = 'commercial'
}

export interface AtlasAccessSearchFilterModel {
  searchText: string
  accessType: EnumAtlasAccessSearchType
}

export interface AtlasAccessTableModel {
  entityId: number
  // DE_SUJETO del cliente/comercial - no el nombre del contacto por el que se filtró
  entityName: string
  entityType: EnumAtlasEntityType
  usersCount: number
}

export interface AtlasAccessKpiModel {
  clientsWithAccessCount: number
  commercialsWithAccessCount: number
  registeredUsersCount: number
  superUsersCount: number
}

export enum EnumAtlasAccessLevel {
  Direct = 'DIRECTO',
  Commercial = 'COMERCIAL'
}

export enum EnumAtlasAccessScope {
  Client = 'CLIENTE',
  Contract = 'CONTRATO',
  Cups = 'CUPS'
}

export interface AtlasAccessDetailFilterModel {
  entityId: number
  entityType: EnumAtlasEntityType
}

// fila de la query "VISIÓN ÚNICA" - usuarios atlas con permisos sobre el sujeto cliente
export interface AtlasRegisteredUserModel {
  userEmail: string
  accessLevel: EnumAtlasAccessLevel
  accessType: EnumAtlasAccessScope
  contractDescription: string | null
  cups: string | null
}

// fila de la query "EMAILS HABILITADOS" - contactos en infocontacto sin usuario atlas asociado
export interface AtlasEnabledEmailModel {
  email: string
  contactType: EnumAtlasAccessScope
  contractDescription: string | null
  cups: string | null
}

// sujetos cliente sobre los que el comercial tiene acceso
export interface AtlasEnabledSubjectModel {
  subjectId: number
  subjectName: string
}

export interface AtlasAccessDetailModel {
  entityName: string | null
  entityCif: string | null
  // usuarios con permiso atlas (EVG_T_G_PERMISO_ATLAS) sobre el sujeto - aplica para Client y Commercial
  registeredUsers: AtlasRegisteredUserModel[]
  // solo se completa si entityType === Client
  enabledEmails: AtlasEnabledEmailModel[]
  // solo se completa si entityType === Commercial
  enabledSubjects: AtlasEnabledSubjectModel[]
}
